webpackJsonp([238154550869096],{

/***/ "./src/assets/feature-icon-placeholder.svg":
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTJweCIgaGVpZ2h0PSI1MnB4IiB2aWV3Qm94PSIwIDAgNTIgNTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ2LjIgKDQ0NDk2KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5PdmFsIDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iSW5pdGlhbC1SZWxlYXNlIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtZGFzaGFycmF5PSIxMCI+CiAgICAgICAgPGcgaWQ9IkhvbWUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04MC4wMDAwMDAsIC05MzcuMDAwMDAwKSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNEREU1RUQiPgogICAgICAgICAgICA8ZyBpZD0iU2VjdGlvbi0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNDEwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlF1b3RlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OS4wMDAwMDAsIDM4MS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLTIiIGN4PSIyNyIgY3k9IjE3MiIgcj0iMjUiPjwvY2lyY2xlPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dale/Documents/cp-website/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-plugin-transform-object-assign/lib/index.js\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"glamor/babel-hoist\"],\"presets\":[[\"/Users/dale/Documents/cp-website/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dale/Documents/cp-website/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dale/Documents/cp-website/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/Feature/index.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _section, _mainFeature, _grid, _circle, _frame, _normal, _info, _mainFeatureGraphic, _section2, _column, _column2;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _prismicDom = __webpack_require__("./node_modules/prismic-dom/dist/prismic-dom.min.js");
	
	var _prismicDom2 = _interopRequireDefault(_prismicDom);
	
	var _presets = __webpack_require__("./src/utils/presets.js");
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _globalStyles = __webpack_require__("./src/utils/global-styles.js");
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _button = __webpack_require__("./src/components/button.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Feature = function (_React$Component) {
	  _inherits(Feature, _React$Component);
	
	  function Feature() {
	    _classCallCheck(this, Feature);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Feature.prototype.render = function render() {
	
	    var feature = this.props.data.prismicDocument.data;
	
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(_reactHelmet.Helmet, { title: _prismicDom2.default.RichText.asText(feature.feature_name) }),
	      Glamor.createElement(
	        'div',
	        { css: styles.section1 },
	        Glamor.createElement(
	          'div',
	          { css: styles.mainFeature },
	          Glamor.createElement(
	            'div',
	            { css: [styles.mainFeatureGraphic, styles.normal] },
	            Glamor.createElement('img', { src: feature.feature_image.url })
	          ),
	          Glamor.createElement(
	            'div',
	            null,
	            Glamor.createElement(
	              'div',
	              { css: _globalStyles2.default.placeholder },
	              Glamor.createElement('img', { src: feature.feature_icon.url ? feature.feature_icon.url : __webpack_require__("./src/assets/feature-icon-placeholder.svg") })
	            ),
	            Glamor.createElement(
	              'a',
	              { href: feature.feature_permalink },
	              Glamor.createElement(
	                'h5',
	                null,
	                _prismicDom2.default.RichText.asText(feature.feature_name)
	              )
	            ),
	            Glamor.createElement(
	              'a',
	              { href: feature.feature_permalink },
	              Glamor.createElement(
	                'h2',
	                null,
	                _prismicDom2.default.RichText.asText(feature.feature_tagline)
	              )
	            ),
	            Glamor.createElement('div', { css: styles.column1, dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(feature.sell) } }),
	            Glamor.createElement(
	              'div',
	              { css: _button.buttonGroupStyle.horizontalLeft },
	              Glamor.createElement(
	                _gatsbyLink2.default,
	                { css: [_button.buttonStyle.button, _button.buttonStyle.outline], to: '/contact-us' },
	                'Book a demo'
	              )
	            )
	          )
	        )
	      ),
	      Glamor.createElement(
	        'div',
	        { css: [styles.section2, _globalStyles2.default.container] },
	        Glamor.createElement('div', { css: styles.column1, dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(feature.feature_body_copy) } }),
	        Glamor.createElement(
	          'div',
	          { css: styles.column2 },
	          feature.features_sidebar.map(function (a, i) {
	            return Glamor.createElement(
	              'div',
	              { key: i },
	              Glamor.createElement('blockquote', { dangerouslySetInnerHTML: { __html: _prismicDom2.default.RichText.asHtml(a.feature_text) } })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Feature;
	}(_react2.default.Component);
	
	exports.default = Feature;
	;
	
	var styles = {
	  section1: (_section = {}, _section[_presets2.default.Desktop] = {
	    padding: '100px'
	  }, _section[_presets2.default.Tablet] = {
	    padding: '100px'
	  }, _section[_presets2.default.Mobile] = {
	    marginBottom: '60px',
	    padding: '50px 25px'
	  }, _section),
	  mainFeature: (_mainFeature = {
	    display: '-webkit-box'
	  }, _mainFeature['display'] = '-moz-box', _mainFeature['display'] = '-ms-flexbox', _mainFeature['display'] = '-webkit-flex', _mainFeature['display'] = 'flex', _mainFeature.alignItems = 'center', _mainFeature[_presets2.default.Desktop] = {
	    flexFlow: 'row'
	  }, _mainFeature[_presets2.default.Tablet] = {
	    flexFlow: 'row'
	  }, _mainFeature[_presets2.default.Mobile] = {
	    flexFlow: 'column'
	  }, _mainFeature),
	  grid: (_grid = {}, _grid[_presets2.default.Desktop] = {
	    maxWidth: '50%',
	    padding: '100px 0'
	  }, _grid[_presets2.default.Tablet] = {
	    maxWidth: '50%',
	    padding: '25px 0'
	  }, _grid[_presets2.default.Mobile] = {
	    padding: '50px 20px',
	    order: 1
	  }, _grid),
	  circle: (_circle = {}, _circle[_presets2.default.Desktop] = {
	    right: '200px',
	    marginRight: '-100px'
	  }, _circle[_presets2.default.Tablet] = {
	    right: '200px',
	    marginRight: '-100px'
	  }, _circle['& img'] = {
	    borderRadius: '100%',
	    '-webkit-box-shadow': 'inset 0px 0px 15px #888888',
	    '-moz-box-shadow': 'inset 0px 0px 15px #888888',
	    boxShadow: 'inset 0px 0px 15px #888888'
	  }, _circle),
	  frame: (_frame = {}, _frame[_presets2.default.Desktop] = {
	    right: '100px'
	  }, _frame[_presets2.default.Tablet] = {
	    right: '100px'
	  }, _frame),
	  normal: (_normal = {}, _normal[_presets2.default.Desktop] = {
	    right: '100px'
	  }, _normal[_presets2.default.Tablet] = {
	    right: '100px'
	  }, _normal),
	  info: (_info = {}, _info[_presets2.default.Desktop] = {
	    display: 'inline-block',
	    width: '40%',
	    margin: '20px 10% 20px 0',
	    verticalAlign: 'top'
	  }, _info[_presets2.default.Tablet] = {
	    display: 'inline-block',
	    width: '40%',
	    margin: '20px 10% 20px 0',
	    verticalAlign: 'top'
	  }, _info),
	  mainFeatureGraphic: (_mainFeatureGraphic = {}, _mainFeatureGraphic[_presets2.default.Desktop] = {
	    position: 'relative',
	    minWidth: '50%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic[_presets2.default.Tablet] = {
	    position: 'relative',
	    minWidth: '50%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic[_presets2.default.Mobile] = {
	    order: 0,
	    width: '100%',
	    maxWidth: '100%',
	    textAlign: 'center'
	  }, _mainFeatureGraphic['& img'] = {
	    maxWidth: '100%'
	  }, _mainFeatureGraphic),
	  section2: (_section2 = {
	    display: 'flex',
	    flexDirection: 'row',
	    margin: '0 auto'
	  }, _section2[_presets2.default.Desktop] = {
	    padding: '0 100px 100px 100px',
	    '& p, & li': {
	      fontSize: '18px',
	      lineHeight: '35px'
	    },
	    '& p': {
	      marginBottom: '40px'
	    },
	    '& .block-img': {
	      textAlign: 'center'
	    }
	  }, _section2[_presets2.default.Tablet] = {
	    padding: '0 50px',
	    '& p, & li': {
	      fontSize: '18px',
	      lineHeight: '35px'
	    },
	    '& p': {
	      marginBottom: '40px'
	    },
	    '& .block-img': {
	      textAlign: 'center'
	    }
	  }, _section2[_presets2.default.Mobile] = {
	    marginBottom: '60px',
	    padding: '0 20px',
	    '& p, & li': {
	      marginLeft: '50px',
	      marginRight: '50px',
	      lineHeight: '30px'
	    },
	    '& p': {
	      marginBottom: '40px'
	    },
	    '& .block-img': {
	      textAlign: 'center'
	    }
	  }, _section2),
	  column1: (_column = {
	    order: 0
	  }, _column[_presets2.default.Desktop] = {
	    flexGrow: 2,
	    '& p': {
	      fontSize: '18px',
	      lineHeight: '35px',
	      marginBottom: '40px'
	    }
	  }, _column[_presets2.default.Tablet] = {
	    flexGrow: 2,
	    '& p': {
	      fontSize: '18px',
	      lineHeight: '35px',
	      marginBottom: '40px'
	    }
	  }, _column),
	  column2: (_column2 = {}, _column2[_presets2.default.Desktop] = {
	    order: 1,
	    flexGrow: 1
	  }, _column2[_presets2.default.Tablet] = {
	    order: 1,
	    flexGrow: 1
	  }, _column2)
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor/react.js")))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-feature-index-js-c422e5642455821f9597.js